/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UnsuspendClusterOrgAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class UnsuspendClusterOrgAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgAuthClusterResponse429ResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UnsuspendClusterOrgAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class UnsuspendClusterOrgAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgAuthClusterResponse409ResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UnsuspendClusterOrgAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class UnsuspendClusterOrgAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgAuthClusterResponse404ResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UnsuspendClusterOrgAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class UnsuspendClusterOrgAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgAuthClusterResponseResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UnsuspendClusterOrgAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UnsuspendClusterOrgAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgAuthClusterResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type UnsuspendClusterOrgResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UnsuspendClusterOrgResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UnsuspendClusterOrgResponseBodyData;

  constructor(
    err: UnsuspendClusterOrgResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UnsuspendClusterOrgResponseBody";
  }
}

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UnsuspendClusterOrgAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UnsuspendClusterOrgAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UnsuspendClusterOrgAuthClusterResponse429ResponseBody
  > = z.instanceof(UnsuspendClusterOrgAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UnsuspendClusterOrgAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UnsuspendClusterOrgAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UnsuspendClusterOrgAuthClusterResponse409ResponseBody
  > = z.instanceof(UnsuspendClusterOrgAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UnsuspendClusterOrgAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UnsuspendClusterOrgAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UnsuspendClusterOrgAuthClusterResponse404ResponseBody
  > = z.instanceof(UnsuspendClusterOrgAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UnsuspendClusterOrgAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UnsuspendClusterOrgAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    UnsuspendClusterOrgAuthClusterResponseResponseBody
  > = z.instanceof(UnsuspendClusterOrgAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponseBody$inboundSchema:
  z.ZodType<UnsuspendClusterOrgAuthClusterResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new UnsuspendClusterOrgAuthClusterResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type UnsuspendClusterOrgAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    UnsuspendClusterOrgAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    UnsuspendClusterOrgAuthClusterResponseBody
  > = z.instanceof(UnsuspendClusterOrgAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UnsuspendClusterOrgResponseBody$inboundSchema: z.ZodType<
  UnsuspendClusterOrgResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UnsuspendClusterOrgResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UnsuspendClusterOrgResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UnsuspendClusterOrgResponseBody$outboundSchema: z.ZodType<
  UnsuspendClusterOrgResponseBody$Outbound,
  z.ZodTypeDef,
  UnsuspendClusterOrgResponseBody
> = z.instanceof(UnsuspendClusterOrgResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
